<form [formGroup]="form"
      (ngSubmit)="onSubmit()">
  <formly-form [form]="form"
               [fields]="fields()"
               [(model)]="model"></formly-form>
  @if (showSubmitButton()) {
    <button type="submit"
            [class]="submitButtonClass()">{{ submitButtonText() }}</button>
  }
</form>